export default {"src":"/_next/static/media/vulnerability-management.e4d5ace5.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};